import React from 'react';

import SportField from './SportField';

class SportPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSport: deleteObjectProperty(props.sport, '__dataID__'),
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      currentSport: deleteObjectProperty(nextProps.sport, '__dataID__'),
    })
  }

  componentDidUpdate(prevProps, prevState){

    let sport = this.state.currentSport;
    this.refs.name.value = this._getName(sport);
    this.refs.logo.value = this._getLogoUrl(sport);
    this.refs.status = this._getStatus(sport);
  }

  onSaveClick() {
    let sport = {};
    if(this.props.sport){
      sport.id = this.state.currentSport.id;
    }
    
    let nameFieldValue = {};
    nameFieldValue[this.props.lang] = this.refs.name.value;

    if(this.props.sport){
      sport.name = Object.assign({}, this.state.currentSport.name, nameFieldValue);
    }else{
      sport.name = nameFieldValue;
    }
    
    sport.logo = this.refs.logo.value;
    sport.levels = this.refs.levels.state.fieldValues;
    sport.positions = this.refs.positions.state.fieldValues;
    sport.certificates = this.refs.certificates.state.fieldValues;
    sport.status = this.state.currentSport ? this.state.currentSport.status : '';
    
    if (this._validSport(sport))
        this.props.onUpdateSport(sport);
    else
      alert('invalid sport');

  }

  _validSport(sport) {
    if(sport.levels.length == 0 )
      return false;
    return true;
  }


  _getLogoUrl(sport){

    let logoUrl = 'http://placehold.it/150x150';
    if(sport && sport.logo && sport.logo.startsWith('http')){
      logoUrl = sport.logo;
    }

    return logoUrl;
  }

  _getName(sport){
    let name = '';
    if(sport && sport.name && sport.name[this.props.lang] ){
      name = sport.name[this.props.lang]
    }
    return name;
  }

  _getStatus(sport) {
    let status = 'ACTIVE';
    if (sport && sport.status) 
      status = sport.status;

    return status ;
  }

  _handleStatusChange(event, sport) {
    sport.status = event.target.value;
    this.setState({
      currentSport: sport
    });
  }

  _renderLogoArea(sport){
    let langFlags = {};
    
    this.props.langList.forEach(lang => {
      let countryCode = lang.toLowerCase();
      if (lang === 'EN')
        countryCode = 'uk';
      langFlags[lang] = `http://www.geonames.org/flags/x/${countryCode}.gif`;
    });
    
    let logoUrl = this._getLogoUrl(sport);

    return (
      <div style={{display:'flex', flexDirection:'column'}}>
          <img 
            src={logoUrl}
            style={{width:150, height:150}}/>
          <input
            ref="logo" 
            className="form-control" 
            placeholder="new logo url" 
            defaultValue={logoUrl}
          />
          <h5>Language is : {this.props.lang}</h5>
          <img src={langFlags[this.props.lang]}
               style={{width:100, height:60}}
          />
      </div>
    )
  }

  _renderStatusField(sport) {
    if (this.props.text == "New")
      return ;

    let status = this._getStatus(sport);

    const sportStatusList = this.props.sportStatusList;

    return (
      <div style={{display: 'flex', flexDirection: 'column', marginTop: 20}}>
        <label>Status</label>
        <select 
          value={status} 
          onChange={(e) => this._handleStatusChange(e, sport)}
          className="form-control" 
          ref="status">
          {
            sportStatusList.map((item, index) => {
              return (<option key={index}>{item.name}</option>)
            })
          }
        </select>
      </div>
    )
  }

  _renderNameField(sport){

    let name = this._getName(sport);

    return (
        <div style={{display: 'flex',flexDirection:'row', paddingBottom:20}}>
          <label>Name</label>
          <div style={{paddingLeft:20}} >
            <input
              ref="name" 
              className="form-control" 
              placeholder="Name" 
              defaultValue={name}
            />
          </div>
        </div>
      )
  }

  

  render() {
    const sport = this.state.currentSport;
    
    let levels = [];
    if(sport && sport.levels && sport.levels.length>0){
      levels = sport.levels;
    }
    levels.sort((levelA, levelB) => {
      return (levelA[this.props.lang].skillLevel - levelB[this.props.lang].skillLevel)
    })
  
    let positions = [];
    if(sport && sport.positions && sport.positions.length > 0 ){
      positions = sport.positions;
    }

    let certificates = [];
    if(sport && sport.certificates && sport.certificates.length > 0){
      certificates = sport.certificates;
    }
    
    return (
      <table className="table table-hover table-condensed table-bordered">
        <tbody>
          <tr>
            <td>
              {this._renderLogoArea(sport)}
              {this._renderStatusField(sport)}
            </td>
            <td>
                <div style={{paddingLeft:20}}>

                  {this._renderNameField(sport)}

                  <SportField 
                    ref="levels"
                    name="Levels" 
                    fieldType="Levels"
                    headerNames={['Name', 'SkillLevel', 'Description', 'Operation']}
                    fieldValues={levels}
                    lang={this.props.lang}
                  />

                  <SportField 
                    ref="positions"
                    name="Positions" 
                    fieldType="Positions"
                    headerNames={['Name', 'Operation']}
                    fieldValues={positions}
                    lang={this.props.lang}
                  />


                  <SportField
                    ref="certificates" 
                    name="Certificates" 
                    fieldType="Certificates"
                    headerNames={['Name', 'Operation']}
                    fieldValues={certificates}
                    lang={this.props.lang}
                  />

                </div>
            </td>
            <td>
              <div style={{paddingLeft:20, display:'flex', flex:1, flexDirection:'center', alignItems:'center'}}>
                <button type="button" className="btn btn-danger btn-lg" onClick={this.onSaveClick.bind(this)}>{this.props.text}</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

SportPanel.propTypes = ({
  sport : React.PropTypes.object,
  lang : React.PropTypes.string.isRequired,
  onUpdateSport : React.PropTypes.func.isRequired,
  text : React.PropTypes.string.isRequired,
});


function deleteObjectProperty(targetObj, targetPro){

    if ( !targetObj ) {
      return targetObj;
    }

    if ( Array.isArray(targetObj) ) {
      targetObj.map( (obj, pro) => deleteObjectProperty(obj, pro));
    }

    for ( let pro of Object.keys(targetObj) ) {

        if( pro == targetPro ){
          delete targetObj[pro];
        }

        if( !targetObj[pro] ){
          continue;  
        }

        if( Array.isArray(targetObj[pro]) ){
          deleteObjectProperty(targetObj[pro], targetPro);
        }

        if( typeof targetObj[pro] == 'object'){
          deleteObjectProperty(targetObj[pro], targetPro);
        }

    }

    return targetObj;

}

export default SportPanel;


// WEBPACK FOOTER //
// ./src/components/SportPanel.js